import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectTimesheetHolidaysGroupedByDate } from 'services/timesheetHolidays/selectors';
import { selectEntities } from 'services/entities/selectors';
import { TimesheetHolidayDate } from 'services/timesheetHolidays/types';
import { EntityId } from 'services/entities/types';
import { AppState } from 'services/types';
import { findEntityHolidayByDate } from 'services/timesheetHolidays/utils';

import { OwnProps } from './index';

const selectTimesheetDate = (
    state: AppState,
    props: OwnProps
): TimesheetHolidayDate => props.timesheetDate;
const selectTimesheetEntityId = (state: AppState, props: OwnProps): EntityId =>
    props.timesheetEntityId;

const selecTimesheetHolidayName = createDeepEqualSelector(
    selectTimesheetDate,
    selectTimesheetEntityId,
    selectTimesheetHolidaysGroupedByDate,
    selectEntities,
    (
        timesheetDate,
        timesheetEntityId,
        timesheetHolidaysGroupedByDate,
        entities
    ) =>
        get(
            findEntityHolidayByDate(
                timesheetDate,
                timesheetEntityId,
                timesheetHolidaysGroupedByDate,
                entities
            ),
            'name'
        )
);

const makeSelectTimesheetHolidayName = (): typeof selecTimesheetHolidayName =>
    selecTimesheetHolidayName;

export { makeSelectTimesheetHolidayName };
